import { render, staticRenderFns } from "./DailyPower.vue?vue&type=template&id=b2c0f636&scoped=true&"
import script from "./DailyPower.vue?vue&type=script&lang=js&"
export * from "./DailyPower.vue?vue&type=script&lang=js&"
import style0 from "./DailyPower.vue?vue&type=style&index=0&id=b2c0f636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c0f636",
  null
  
)

export default component.exports